import { IRequestContext } from '@msdyn365-commerce/core';
import { useEffect, useState } from 'react';
import { getGenderCookie } from '../gender-cookie-service';
import { GENDER_COOKIE_CHANGED_EVENT } from '../gender-cookie-service.const';
import { Gender } from '../gender-cookie-service.types';

export const useGenderCookieValue = (request: IRequestContext): Gender | undefined => {
    const [gender, setGender] = useState<Gender | undefined>(() => getGenderCookie(request));

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const refreshGender = (): void => {
            setGender(getGenderCookie(request));
        };

        window.addEventListener(GENDER_COOKIE_CHANGED_EVENT, refreshGender);
        refreshGender();

        return () => window.removeEventListener(GENDER_COOKIE_CHANGED_EVENT, refreshGender);
    }, [request]);

    return gender;
};
